module.exports = __webpack_public_path__ + "images/emoji/leftwards_arrow_with_hook.88f35f21c8bd91c2b401.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/leftwards_arrow_with_hook.png
// module id = IlM/
// module chunks = 13